import React from "react";
import SEOHead from "../section/SeoHead";
import FaqContactSection from "../section/FaqContactSection";
import ContactForm from "../section/ContactForm";
import GetInTouchSection from "../section/GetInTouchSection";
import ContactHeroSection from "../section/ContactHeroSection";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const { t } = useTranslation();
  UseScrollAnimation();

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: t("contact_page.seo.title"),
    description: t("contact_page.seo.description"),
    mainEntity: {
      "@type": "LocalBusiness",
      name: "Citizen Hub Immigration Services",
      telephone: "+1 3108802133",
      email: "info@citznhub.com",
      address: [
        {
          "@type": "PostalAddress",
          streetAddress: "123 Immigration Plaza, Suite 100",
          addressLocality: "Washington",
          addressRegion: "DC",
          postalCode: "20001",
        },
      ],
    },
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SEOHead
        title={t("contact_page.seo.title")}
        description={t("contact_page.seo.description")}
        keywords={t("contact_page.seo.keywords")}
        canonicalUrl="https://citizenhubimmigration.com/contact"
        structuredData={structuredData}
      />
      <ContactHeroSection />

      <GetInTouchSection />
      <ContactForm />
      <FaqContactSection />
    </div>
  );
};

export default ContactUs;
